import { SORT_VALUE } from './constants';
import { LAYOUT_BATCH_MODE, LAYOUT_BUNDLING } from '../../layout';

function isApplicable(layout) {
  return layout === LAYOUT_BATCH_MODE || layout === LAYOUT_BUNDLING;
}

// eslint-disable-next-line import/prefer-default-export
export function autoEnableShipmentBundling(layout, parameters) {
  // enabled
  const applicable = isApplicable(layout);
  if (applicable) {
    // eslint-disable-next-line no-param-reassign
    parameters.orderBy = SORT_VALUE;
    if (layout === LAYOUT_BUNDLING) {
      parameters.includes.push('customer_request.printing_request.bundled_shipment.shipping_cost');
      parameters.includes.push('rx_form.shipping_location');
      parameters.includes.push('bundled_shipment.shipping_cost');
    }
  }

  // disable
  if (!applicable && parameters.orderBy === SORT_VALUE) {
    // eslint-disable-next-line no-param-reassign
    parameters.orderBy = 'ship_date_sort';
    // eslint-disable-next-line no-param-reassign
    parameters.order = 'asc';
  }
}
